/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";


// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// sweetalert2 components
import Swal from "sweetalert2";

// @mui material components
// import Grid from "@mui/material/Grid";
// import Icon from "@mui/material/Icon";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/system";
// import TableContainer from "@mui/material/TableContainer";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";

import { Grid, Icon, TableContainer, Tabs, Tab, Checkbox, FormControl, FormControlLabel, FormGroup, Card } from "@mui/material";

const globalCss = require("assets/theme/base/globals");

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import SoftInput from "components/SoftInput";
import SoftProgress from "components/SoftProgress";

// Wizard application components
import FormField from "layouts/applications/wizard/components/FormField";

import { putData, postData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

import { useSoftUIController } from "context";
import Skill90OddFactorPriceSettings from "../../components/Skill90OddFactorPriceSettings";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <SoftBox sx={{}}>
          <SoftBox>{children}</SoftBox>
        </SoftBox>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

let restPercentageCache = 0;

function NewOddsFilter({ id, initData, providers, signalCloseModal, checkChanges }) {
  const [Skill90OddFactorPriceSettingsData, setSkill90OddFactorPriceSettingsData] = useState([
    { value: "1.00", operator: "x" },
  ]);
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;

  const [selectedProviders, setSelectedProviders] = useState([]);
  const [loadedData, setInitData] = useState("");

  const [provider, setProvider] = useState({ id: 1000, name: "FTB" });
  const [selectedTab, setSelectedTab] = useState(0);
  const [oddFilterNameError, setOddFilterNameError] = useState("");
  const [barrierMinError, setBarrierMinError] = useState("");
  const [barrierMaxError, setBarrierMaxError] = useState("");
  const [barrierStaticError, setBarrierStaticError] = useState("");
  const [marginValueError, setMarginValueError] = useState("");
  const [mixingOddValueError, setMixingOddValueError] = useState("");
  const [mixingProviderError, setMixingProviderError] = useState("");
  const [mixingPercentageError, setMixingPercentageError] = useState(null);
  const [mixingTypeError, setMixingTypeError] = useState("");
  const [validationError, setValidationError] = useState([{}]);
  const [triggerValidationError, setTriggerValidationError] = useState(false);
  const [validationChildError, setValidationChildError] = useState([{}]);
  const [triggerValidationChildError, setTriggerValidationChildError] = useState(false);
  const [tabError, setTabError] = useState([]);

  const [minBarrier, setMinBarrier] = useState(1.0);
  const [oddFilterName, setOddFilterName] = useState(null);
  const [maxBarrier, setMaxBarrier] = useState(1000.0);
  const [staticBarrier, setStaticBarrier] = useState([{}]);
  const [mixingOddValue, setMixingOddValue] = useState(0.0);
  const [marginValue, setMarginValue] = useState(0.0);
  const [marginTypes, setMarginTypes] = useState([
    { value: 0, label: "No Margin", info: "" },
    { value: 1, label: "All odds get same margin (EM)", info: "" },
    { value: 2, label: "Highest odds get more margin (MPTO)", info: "" },
    { value: 3, label: "Lowest odds get more margin (MPTP)", info: "" },
  ]);
  const [suspensionTypes, setSuspensionTypes] = useState([
    { value: 0, label: "Never", info: "" },
    { value: 1, label: "One Provider Suspend Odds", info: "" },
    { value: 2, label: "All Providers Suspend Odds", info: "" },
    { value: 3, label: "The Most of the Providers Suspend Odds", info: "" },
    // { value: 4, label: "Ordered Providers Suspend Odd", info: "" },
    { value: 5, label: "According sorted Providers", info: "" },
  ]);
  const [barrierTypes, setBarrierTypes] = useState([]);
  const [mixingTypes, setMixingTypes] = useState([]);
  const [mixingProviders, setMixingProviders] = useState([]);
  const [mixingProvidersMarkets, setMixingProvidersMarkets] = useState([]);
  const [selectedMixingProviders, setSelectedMixingProviders] = useState([]);
  const [randomFactorTypes, setRandomFactorTypes] = useState([]);

  const [mainPercentage, setMainPercentage] = useState(0);
  const [restPercentage, setRestPercentage] = useState(0);

  const [barrierType, setBarrierType] = useState({ value: 0, label: "Do Nothing", info: "" });
  const [marginType, setMarginType] = useState({
    value: 0,
    label: "No Margin",
    info: "",
  });
  const [suspensionType, setSuspensionType] = useState({ value: 0, label: "Never", info: "" });
  const [suspensionProviderBarrier, setSuspensionProviderBarrier] = useState([]);
  const [mixingType, setMixingType] = useState({ value: 0, label: "No Mixing", info: "" });
  const [mixingProvider, setMixingProvider] = useState({ value: 0, label: "None", info: "" });
  const [randomFactor, setRandomFactor] = useState({
    value: false,
    label: "Always Apply",
    info: "",
  });

  const [tabs, setTabs] = useState([]);
  const [infoDataOddSettings, setInfoDataOddSettings] = useState("");
  const [infoData, setInfoData] = useState("");
  const [infoPercentageData, setInfoPercentageData] = useState(
    "While there are no data from one of the selected providers then this percentage will be added to the Main Provider."
  );
  const [oddsFilters, setOddsFilters] = useState([{}]);
  const [mode, setMode] = useState("create");
  const [value, setValue] = useState(0);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  let tabsStatic = [
    {
      id: 0,
      label: "Odds Limits setup",
      value: "barrier",
      config: {
        type: [
          { value: 0, label: "Do Nothing", info: "" },
          {
            value: 1,
            label: "Suspend Odds",
            info: "Suspend ONLY the Odd that is Lower or Greater than Minimum and Maximum Prices.",
          },
          {
            value: 2,
            label: "Set Odds to Limits",
            info: "Set ALL Odds prices Lower or Greater than Minimum and Maximum Prices, to these Prices.",
          },
          {
            value: 3,
            label: "Suspend Market",
            info: "Suspend ALL the Odds and the Market in case any Odd of the Market is Lower or Greater than Minimum and Maximum Prices.",
          },
        ],
        min: "0",
        max: "0",
        static: "0",
        random: [
          { value: true, label: "Random Apply", info: "" },
          { value: false, label: "Always Apply", info: "" },
        ],
      },
    },
    {
      id: 1,
      label: "mixing options",
      value: "mixing",
      config: {
        type: [
          {
            value: 0,
            label: "No Mixing",
            info: "NOT mixing any ",
          },
          {
            value: 1,
            label: "Highest Price",
            info: "Get the Highest Price of each Odd between ",
          },
          {
            value: 2,
            label: "Percentage Weight",
            info: "Get the Price of each Odd based on the Percentage Weight you have set between ",
          },
        ],
        provider: [],
      },
    },
  ];

  
  const css = globalCss ? globalCss.default : null;
  const customColors = css.customColors;

  const handleDataChange = (data) => {
    setSkill90OddFactorPriceSettingsData(data);
  };

  const handleValidationError = (errors) => {
    if (errors.length > 0) {
      setValidationChildError(errors);
      setTriggerValidationChildError(true);
    } else {
      setValidationChildError([]);
      setTriggerValidationChildError(true);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleProviderChange = (event) => {
    event.preventDefault();
    let selectedprovider = mixingProviders.find((provider) => provider.value == event.target.name);

    const tmpSelectedProviders = [...selectedProviders];

    if (selectedprovider) {
      selectedprovider.selected = !selectedprovider.selected;
      if (selectedprovider.selected) {
        tmpSelectedProviders.push(selectedprovider);
      } else {
        const previousRowsIndex = tmpSelectedProviders.findIndex(
          (provider) => provider.value === selectedprovider.value
        );
        tmpSelectedProviders[previousRowsIndex].percentage = 0;
        tmpSelectedProviders[previousRowsIndex].percentageToShow = null;
        let percentage = 0;
        for (let index = 0; index < tmpSelectedProviders.length; index++) {
          const provider = tmpSelectedProviders[index];
          const providerPercentage = provider.percentage;
          if (provider.percentage == 0) provider.percentageToShow = null;
          percentage = percentage + providerPercentage;
        }
        setRestPercentage(percentage);
        restPercentageCache = percentage;
        tmpSelectedProviders.splice(previousRowsIndex, 1);
      }
    }

    let userSettedPercentage = 0;
    tmpSelectedProviders.map((p) => {
      if (p.percentageToShow) userSettedPercentage += p.percentage;
    });

    const autoPercentageProviders = tmpSelectedProviders.filter((p) => !p.percentageToShow);
    let percentage = 0;
    tmpSelectedProviders.map((p) => {
      if (!p.percentageToShow)
        p.percentage = parseFloat(
          (100 - userSettedPercentage) / autoPercentageProviders.length
        ).toFixed(2);
      percentage += p.percentage;
    });
    setRestPercentage(percentage);

    tmpSelectedProviders.sort((a, b) => parseInt(b.percentage) - parseInt(a.percentage));

    let tmpOddsFilters = oddsFilters;
    tmpOddsFilters.mixing_providers = tmpSelectedProviders;
    setOddsFilters(tmpOddsFilters);

    setSelectedProviders([]);
    setSelectedProviders(tmpSelectedProviders);
    validateData(tmpOddsFilters);
  };

  const keyDownHandler = (event) => {
    //console.log("Key DOWN Handling");
    if (event.code === "Enter") {
      handleSortingProviderPercentage(event);
    }
  };

  const handleProviderPercentage = (event) => {
    event.preventDefault();

    // if (!parseInt(event.target.value) && event.target.value !== 0) {
    //   event.target.value = 0;
    // }

    // if (parseInt(event.target.value) < 0) {
    //   event.target.value = 0;
    // }

    if (event.target.value.indexOf(".") == event.target.value.length - 1) return;

    event.target.value = event.target.value ? parseFloat(event.target.value) : null;

    let selectedprovider = selectedProviders.find(
      (provider) => provider.label == event.target.name
    );

    selectedprovider.percentage = event.target.value ? parseFloat(event.target.value) : null;
    selectedprovider.percentageToShow = event.target.value ? parseFloat(event.target.value) : null;

    let tmpSelectedProviders = [...selectedProviders];
    let userSettedPercentage = 0;
    tmpSelectedProviders.map((p) => {
      if (p.percentageToShow) userSettedPercentage += p.percentage;
    });

    const autoPercentageProviders = tmpSelectedProviders.filter((p) => !p.percentageToShow);
    tmpSelectedProviders.map((p) => {
      if (!p.percentageToShow)
        p.percentage = parseFloat(
          (100 - userSettedPercentage) / autoPercentageProviders.length
        ).toFixed(2);
    });

    tmpSelectedProviders.sort((a, b) => parseInt(b.percentage) - parseInt(a.percentage));
  };

  const handleSortingProviderPercentage = (event) => {
    event.preventDefault();
    let percentage = 0;
    let tmpselectedProviders = [...selectedProviders];
    tmpselectedProviders.sort((a, b) => parseInt(b.percentage) - parseInt(a.percentage));

    for (let index = 0; index < tmpselectedProviders.length; index++) {
      const provider = tmpselectedProviders[index];
      const providerPercentage = provider.percentage;
      if (provider.percentage == 0) provider.percentageToShow = null;
      percentage = percentage + providerPercentage;
    }

    let tmpOddsFilters = oddsFilters;
    tmpOddsFilters.mixing_providers = tmpselectedProviders;

    setOddsFilters(tmpOddsFilters);
    setSelectedProviders(tmpselectedProviders);
    setRestPercentage(percentage);
    restPercentageCache = percentage;
    setMixingPercentageError(null);

    if (percentage >= 100 - mainPercentage) {
      setMixingPercentageError(true);
      let tabErrors = [];
            //setBarrierMinError(printMessage);
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);

      setTabError(tabErrors);
      let validationError = [
        {
          handleSortingProviderPercentage:
            "There are some errors, in the other tab, you must moderate before to continue.",
        },
      ];

      setValidationError(validationError);
    } else {
      validateData(tmpOddsFilters);
    }

    if (provider.id == 1000) {
      setMixingPercentageError(null);
      if (percentage < 100 - mainPercentage) {
        setMixingPercentageError(true);
        let tabErrors = [];
                //setBarrierMinError(printMessage);
        if (tabErrors.indexOf(0) < 0) tabErrors.push(0);

        setTabError(tabErrors);
        let validationError = [
          {
            handleSortingProviderPercentage:
              "There are some errors, in the other tab, you must moderate before to continue.",
          },
        ];

        setValidationError(validationError);
      } else if (percentage > 100 - mainPercentage) {
        setMixingPercentageError(true);
        let tabErrors = [];
                //setBarrierMinError(printMessage);
        if (tabErrors.indexOf(0) < 0) tabErrors.push(0);

        setTabError(tabErrors);
        let validationError = [
          {
            handleSortingProviderPercentage:
              "There are some errors, in the other tab, you must moderate before to continue.",
          },
        ];

        setValidationError(validationError);
      } else {
        validateData(tmpOddsFilters);
      }
    }
  };

  const getStaticData = async () => {
    if (!providers || providers.length == 0) return;
    //console.log("Odds getData....", data);
    setMixingProvidersMarkets(null);

    setBarrierTypes(tabsStatic[0].config.type);
    //setRandomFactorTypes(tabsStatic[0].config.random);

    let mixingTypesFiltered = tabsStatic[1].config.type;
    setMixingTypes(mixingTypesFiltered);

    let filteredProviders = [];
    // let providerToCheck = provider;

    // if (initData.provider) {
    //   providerToCheck = initData.provider;
    //   setProvider(initData.provider);
    // }

    providers.forEach((element) => {
      if (element.id != 1000) {
        filteredProviders.push({
          value: element.id,
          label: element.name,
          info: "",
          selected: false,
          percentageToShow: null,
          percentage: 0,
        });
      }
    });

    setMixingProviders(filteredProviders);
    setMixingProvidersMarkets(filteredProviders);
    setSelectedProviders([]);
    setTabs(0);
  };

  const getDataFromDB = async (data) => {
    if (!providers || providers.length == 0) return;
    if (!platform) return;

    setMode("edit");

    let oddsFilters = { ...data };

    if (oddsFilters) {
      //console.log("Odds getDataFromDB....");
      // let currentTemplateId = initData.template;
      // let currentProviderId = initData.provider.id;
      // if (data) {
      //   //console.log(data);
      //   currentTemplateId = data.split("--")[0].trim();
      //   currentProviderId = data.split("--")[1].trim();
      // } else {
      // }

      // let getOddsFiltersEndpoint = `/api/v1/oddsfilters/${id}`;

      // let response = await getData(getOddsFiltersEndpoint, {
      //   Authorization: getAuthorizationHeader(),
      // });

      // if (response != null) {
      //   let oddsFilters = response.data.length > 0 ? response.data[0] : {};
      //   if (JSON.stringify(oddsFilters) == "{}") {
      //     oddsFilters = {
      //       barrier_reaction_type: 0,
      //       margin_type: 0,
      //       margin_percent: 0.0,
      //       min_odd_barrier: 1.0,
      //       max_odd_barrier: 1000.0,
      //       mixing_odd_type: 0,
      //       suspension_type: 0,
      //       suspension_provider: [],
      //       static_odd_reaction: 0.0,
      //       random_odd_reaction: false,
      //       mixing_providers: [],
      //       mixing_odd_limit: 0.0,
      //     };
      //   }

      // if (oddsFilters.provider_id !== 1000) {
      //   oddsFilters.mixing_odd_type = 0;
      //   oddsFilters.mixing_providers = [];
      //   oddsFilters.mixing_odd_limit = 0.0;
      // }
      setOddFilterName(oddsFilters.name);
      setMinBarrier(parseFloat(oddsFilters.min_odd_barrier).toFixed(2));
      setMaxBarrier(parseFloat(oddsFilters.max_odd_barrier).toFixed(2));
      setSkill90OddFactorPriceSettingsData(oddsFilters.static_odd_reaction_json);
      setMarginValue(
        parseFloat(oddsFilters.margin_percent) % 1 == 0
          ? parseFloat(oddsFilters.margin_percent)
          : parseFloat(oddsFilters.margin_percent).toFixed(2)
      );
      setMixingOddValue(
        parseFloat(oddsFilters.mixing_odd_limit) % 1 == 0
          ? parseFloat(oddsFilters.mixing_odd_limit)
          : parseFloat(oddsFilters.mixing_odd_limit).toFixed(2)
      );

      let percentage = 0;
      for (let index = 0; index < oddsFilters.mixing_providers.length; index++) {
        const mixingProvider = oddsFilters.mixing_providers[index];
        const tmpPercentage = mixingProvider.percentage;
        mixingProvider.percentage = tmpPercentage;
        mixingProvider.percentageToShow = mixingProvider.auto
          ? null
          : tmpPercentage == 0
          ? null
          : tmpPercentage;
        mixingProvider.value = mixingProvider.id;
        mixingProvider.label = mixingProvider.name;
        percentage = percentage + tmpPercentage;
      }

      let userSettedPercentage = 0;
      oddsFilters.mixing_providers.map((p) => {
        if (p.percentageToShow) userSettedPercentage += p.percentage;
      });

      const autoPercentageProviders = oddsFilters.mixing_providers.filter(
        (p) => !p.percentageToShow
      );
      oddsFilters.mixing_providers.map((p) => {
        if (!p.percentageToShow)
          p.percentage = (100 - userSettedPercentage) / autoPercentageProviders.length;
      });

      setRestPercentage(percentage);
      restPercentageCache = percentage;

      let tmp_barrier_reaction_type = tabsStatic[0].config.type.find(
        (option) => option.value == oddsFilters.barrier_reaction_type
      );
      let tmp_mixing_odd_type = tabsStatic[1].config.type.find(
        (option) => option.value == oddsFilters.mixing_odd_type
      );
      let tmp_suspension_type = suspensionTypes.find(
        (option) => option.value == oddsFilters.suspension_type
      );
      let tmp_mixing_providers = JSON.parse(JSON.stringify(oddsFilters.mixing_providers));
      let tmp_factor_random = tabsStatic[0].config.random.find(
        (option) => option.value == oddsFilters.random_odd_reaction
      );
      let tmp_margin_type = oddsFilters.margin_type
        ? marginTypes.find((option) => option.value == oddsFilters.margin_type)
        : marginTypes[0];

      oddsFilters.suspension_provider = oddsFilters.suspension_provider_id
        ? oddsFilters.suspension_provider_id.split(",")
        : [];

      let tmp_suspension_provider = [];
      for (let index = 0; index < oddsFilters.suspension_provider.length; index++) {
        const providerId = oddsFilters.suspension_provider[index];
        const provider = providers.find((option) => option.id == providerId);
        if (provider)
          tmp_suspension_provider.push({
            value: provider.id ? provider.id : provider.value,
            label: provider.name ? provider.name : provider.label,
            info: "",
            key: provider.id ? provider.id : provider.value,
          });
      }

      setBarrierType(JSON.parse(JSON.stringify(tmp_barrier_reaction_type)));
      setMixingType(JSON.parse(JSON.stringify(tmp_mixing_odd_type)));
      setSuspensionType(JSON.parse(JSON.stringify(tmp_suspension_type)));
      setSuspensionProviderBarrier(JSON.parse(JSON.stringify(tmp_suspension_provider)));
      setSelectedProviders(tmp_mixing_providers);
      setRandomFactor(JSON.parse(JSON.stringify(tmp_factor_random)));
      setMarginType(JSON.parse(JSON.stringify(tmp_margin_type)));

      document.getElementById("odd-filter-name")
        ? (document.getElementById("odd-filter-name").value = oddsFilters.name)
        : null;
      document.getElementById("barrier-minimum")
        ? (document.getElementById("barrier-minimum").value = parseFloat(
            oddsFilters.min_odd_barrier
          ).toFixed(2))
        : null;
      document.getElementById("barrier-maximum")
        ? (document.getElementById("barrier-maximum").value = parseFloat(
            oddsFilters.max_odd_barrier
          ).toFixed(2))
        : null;

      document.getElementById("margin-value")
        ? (document.getElementById("margin-value").value = parseFloat(
            oddsFilters.margin_percent
          ).toFixed(1))
        : null;

      let filters = {
        odd_filter_name: oddsFilters.name,
        platform: platform.value,
        barrier_reaction_type: JSON.parse(JSON.stringify(tmp_barrier_reaction_type)),
        min_odd_barrier: parseFloat(oddsFilters.min_odd_barrier).toFixed(2),
        max_odd_barrier: parseFloat(oddsFilters.max_odd_barrier).toFixed(2),
        static_odd_reaction: oddsFilters.static_odd_reaction_json,
        margin_percent:
          parseFloat(oddsFilters.margin_percent) % 1 == 0
            ? parseFloat(oddsFilters.margin_percent)
            : parseFloat(oddsFilters.margin_percent).toFixed(2),
        random_odd_reaction: JSON.parse(JSON.stringify(tmp_factor_random)),
        mixing_odd_type: JSON.parse(JSON.stringify(tmp_mixing_odd_type)),
        margin_type: JSON.parse(JSON.stringify(tmp_margin_type)),
        suspension_type: JSON.parse(JSON.stringify(tmp_suspension_type)),
        suspension_provider: JSON.parse(JSON.stringify(tmp_suspension_provider)),
        mixing_providers: JSON.parse(JSON.stringify(tmp_mixing_providers)).map((item) => {
          return {
            provider_id: item.value,
            provider_name: item.label,
            percentage: item.percentage,
            percentageToShow: item.percentage ? item.percentage : null,
          };
        }),
        mixing_odd_limit:
          parseFloat(oddsFilters.mixing_odd_limit) % 1 == 0
            ? parseFloat(oddsFilters.mixing_odd_limit)
            : parseFloat(oddsFilters.mixing_odd_limit).toFixed(2),
      };

      setInitData(JSON.stringify(filters).replace("MAINPROVIDER", ""));

      let info = tmp_mixing_odd_type.info.replace("MAINPROVIDER", provider.name.toUpperCase());
      setInfoData(info + " selected Providers");

      setOddsFilters(filters);

      validateData(filters);
    } else {
      //console.log("no Data");
    }
  };

  function selectTab(tabId) {
    if (!tabsStatic) return;
    if (selectedTab === tabId) return;
    const tab = tabsStatic.find((tab) => {
      return tab.id === tabId;
    });
    if (!tab) return;
    tab.selected = true;

    setSelectedTab(tabId);

    if (tabId == 1) {
      let infodata = tabsStatic[1].config.type.find(
        (option) => option.value == oddsFilters.mixing_odd_type
      );
      if (infodata) {
        setInfoData(
          infodata.info.replace(
            "MAINPROVIDER",
            provider.name.toUpperCase() + " other selected Providers"
          )
        );
      }
    }
  }

  const handleInputValueChange = (e) => {
    validateData();
  };

  const handleFiltersSelectionsChange = (item, type) => {
    if (type == "mixing-provider") {
      setInfoData(infoData.replace("MAINPROVIDER", provider.name.toUpperCase()));
      setInfoData(infoData.split(" and ")[0] + " and " + item.label.toUpperCase());
    } else if (type == "mixing-type") {
      setInfoPercentageData("");
      item.info = item.info.replace("MAINPROVIDER", provider.name.toUpperCase());
      setInfoData(infoData.replace("MAINPROVIDER", provider.name.toUpperCase()));
      setInfoData(item.info + " other selected Providers");
      if (item.value === 2)
        setInfoPercentageData(
          "While there are no data from one of the selected providers then this percentage will be added to the Main Provider."
        );
    } else if (type == "barrier-type") {
      item.info = item.info.replace("MAINPROVIDER", provider.name.toUpperCase());
      setInfoDataOddSettings(infoData.replace("MAINPROVIDER", provider.name.toUpperCase()));
      setInfoDataOddSettings(item.info);
    } else if (type == "suspension-type") {
      // item.info = item.info.replace("MAINPROVIDER", provider.name.toUpperCase());
      // setInfoDataOddSettings(infoData.replace("MAINPROVIDER", provider.name.toUpperCase()));
      // setInfoDataOddSettings(item.info);
    } else if (type == "suspension-provider-barrier") {
    } else {
      item.info = item.info.replace("MAINPROVIDER", provider.name.toUpperCase());
      setInfoData(infoData.replace("MAINPROVIDER", provider.name.toUpperCase()));
      setInfoData(item.info);
    }
    let resetProvider = null;
    let suspensionProvidersPriority = null;

    if (type == "barrier-type") setBarrierType(item);
    if (type == "margin-type") {
      setMarginType(item);
      if (item.value == 0) {
        setMarginValue(0.0);
        document.getElementById("margin-value").value = "0.0";
      }
    }
    if (type == "mixing-type") {
      if (item.value == "0") {
        resetProvider = { value: 0, label: "None", info: "" };
        setMixingProvider(resetProvider);
      }
      setMixingType(item);
    }
    if (type == "suspension-type") {
      if (item.value != "5") {
        resetProvider = [];
        setSuspensionProviderBarrier(resetProvider);
      }
      setSuspensionType(item);
    }

    if (type == "mixing-provider") setMixingProvider(item);
    if (type == "factor-random") setRandomFactor(item);
    if (type == "suspension-provider-barrier") {
      suspensionProvidersPriority = [...suspensionProviderBarrier];
      const providerIndex = suspensionProviderBarrier.findIndex((spb) => spb.value == item.value);
      if (providerIndex > -1) {
        suspensionProvidersPriority.splice(providerIndex, 1);
      } else {
        suspensionProvidersPriority.push(item);
      }
      setSuspensionProviderBarrier(suspensionProvidersPriority);
    }

    let filters = {
      odd_filter_name: document.getElementById("odd-filter-name")
        ? document.getElementById("odd-filter-name").value
        : oddsFilters.odd_filter_name,
      platform: platform.value,
      barrier_reaction_type: type == "barrier-type" ? item : barrierType,
      min_odd_barrier: document.getElementById("barrier-minimum")
        ? document.getElementById("barrier-minimum").value
        : oddsFilters.min_odd_barrier,
      max_odd_barrier: document.getElementById("barrier-maximum")
        ? document.getElementById("barrier-maximum").value
        : oddsFilters.max_odd_barrier,
      static_odd_reaction: Skill90OddFactorPriceSettingsData
        ? Skill90OddFactorPriceSettingsData
        : oddsFilters.static_odd_reaction_json,
      margin_percent: document.getElementById("margin-value")
        ? document.getElementById("margin-value").value
        : oddsFilters.margin_percent,
      random_odd_reaction: randomFactor,
      mixing_odd_type: type == "mixing-type" ? item : mixingType,
      margin_type: type == "margin-type" ? item : marginType,
      suspension_type: type == "suspension-type" ? item : suspensionType,
      suspension_provider:
        type == "suspension-provider-barrier"
          ? suspensionProvidersPriority
          : suspensionType !== 5
          ? null
          : suspensionProviderBarrier,
      mixing_providers: selectedProviders,
      mixing_odd_limit: document.getElementById("mixing-providers-limit-value")
        ? document.getElementById("mixing-providers-limit-value").value
        : oddsFilters.mixing_odd_limit,
    };

    setMinBarrier(filters.min_odd_barrier);
    setMaxBarrier(filters.max_odd_barrier);
    setSkill90OddFactorPriceSettingsData(filters.static_odd_reaction);
    setMarginValue(filters.margin_percent);
    setMixingOddValue(filters.mixing_odd_limit);
    setOddFilterName(filters.odd_filter_name);
    setOddsFilters(filters);
    validateData(filters);
  };

  const handleFocusOut = (e) => {
    e.preventDefault();
    e.currentTarget.value =
      e.currentTarget.id == "margin-value" || e.currentTarget.id == "mixing-providers-limit-value"
        ? e.currentTarget.value * 1
        : e.currentTarget.id == "odd-filter-name"
        ? e.currentTarget.value
        : parseFloat(e.currentTarget.value).toFixed(2);

    let filters = {
      odd_filter_name: document.getElementById("odd-filter-name")
        ? document.getElementById("odd-filter-name").value
        : oddsFilters.odd_filter_name,
      platform: platform.value,
      barrier_reaction_type: barrierType,
      min_odd_barrier: document.getElementById("barrier-minimum")
        ? document.getElementById("barrier-minimum").value
        : oddsFilters.min_odd_barrier,
      max_odd_barrier: document.getElementById("barrier-maximum")
        ? document.getElementById("barrier-maximum").value
        : oddsFilters.max_odd_barrier,
      static_odd_reaction: Skill90OddFactorPriceSettingsData
        ? Skill90OddFactorPriceSettingsData
        : oddsFilters.static_odd_reaction
        ? oddsFilters.static_odd_reaction
        : [{}],
      margin_percent: document.getElementById("margin-value")
        ? document.getElementById("margin-value").value
        : oddsFilters.margin_percent,
      random_odd_reaction: randomFactor,
      mixing_odd_type: mixingType,
      suspension_type: suspensionType,
      margin_type: marginType,
      suspension_provider: suspensionProviderBarrier,
      mixing_providers: selectedProviders,
      mixing_odd_limit: document.getElementById("mixing-providers-limit-value")
        ? document.getElementById("mixing-providers-limit-value").value
        : oddsFilters.mixing_odd_limit,
    };

    setMinBarrier(filters.min_odd_barrier);
    setMaxBarrier(filters.max_odd_barrier);
    setSkill90OddFactorPriceSettingsData(filters.static_odd_reaction);
    setMarginValue(filters.margin_percent);
    setMixingOddValue(filters.mixing_odd_limit);
    setOddFilterName(filters.odd_filter_name);
    setOddsFilters(filters);
    validateData(filters);
  };

  const validateData = (data) => {
    let oddsFiltersToValidate = data
      ? JSON.parse(JSON.stringify(data))
      : JSON.parse(JSON.stringify(oddsFilters));
    if (JSON.stringify(oddsFiltersToValidate) == "{}") {
      oddsFiltersToValidate = {
        barrier_reaction_type: barrierType,
        margin_type: marginType,
        min_odd_barrier: 1.0,
        max_odd_barrier: 1000.0,
        mixing_odd_type: mixingType,
        static_odd_reaction: [{}],
        margin_percent: 0.0,
        mixing_providers: selectedProviders,
        mixing_odd_limit: 0.0,
      };
    }

    let invalid = false;
    let printMessage = "";
    let tabErrors = [];

    setOddFilterNameError("");
    setBarrierMinError("");
    setBarrierMaxError("");
    setBarrierStaticError("");
    setMarginValueError("");
    setMixingOddValueError("");
    setMixingProviderError("");
    setMixingTypeError("");
    setTabError([]);

    if (
      oddsFiltersToValidate?.mixing_providers &&
      oddsFiltersToValidate.mixing_providers.length === 0 &&
      oddsFiltersToValidate.mixing_odd_type.value != "0"
    ) {
      invalid = true;
      tabErrors.push(1);
    } else {
      invalid = false;
    }

    oddsFiltersToValidate.mixing_providers = oddsFiltersToValidate.mixing_providers
      ? oddsFiltersToValidate.mixing_providers
      : selectedMixingProviders;

    let restPercentage = restPercentageCache;
    if (oddsFiltersToValidate.mixing_providers.length > 0) {
      if (provider.id == 1000) {
        if (
          restPercentage < 100 - mainPercentage &&
          oddsFiltersToValidate.mixing_odd_type.value == 2
        ) {
          invalid = true;
          if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
        } else if (restPercentage > 100 - mainPercentage) {
          invalid = true;
          if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
        }
      } else {
        if (
          restPercentage >= 100 - mainPercentage &&
          oddsFiltersToValidate.mixing_odd_type.value == 2
        ) {
          invalid = true;
          printMessage = "The number can't be less than 1.";
          let message = [{ mixing_odd_type: "The number can't be less than 1." }];
          setValidationError(message);
          setTriggerValidationError(true);
          //setBarrierMinError(printMessage);
          if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
        }
      }
    }

    if (
      typeof oddsFiltersToValidate.odd_filter_name != "undefined" &&
      JSON.parse(JSON.stringify(oddsFiltersToValidate.odd_filter_name)) == ""
    ) {
      printMessage = "Missing Odds Filter Name.";
      let message = [{ odd_filter_name: "Missing Odds Filter Name." }];
      setValidationError(message);
      setTriggerValidationError(true);
      setOddFilterNameError(printMessage);
      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (
      typeof oddsFiltersToValidate.min_odd_barrier != "undefined" &&
      JSON.parse(JSON.stringify(oddsFiltersToValidate.min_odd_barrier)) == ""
    ) {
      printMessage = "Missing Odds value.";
      if (JSON.parse(JSON.stringify(oddsFiltersToValidate.barrier_reaction_type)).value != "0") {
      }
      let message = [{ min_odd_barrier: "Missing Odds value." }];
      setValidationError(message);
      setTriggerValidationError(true);
      setBarrierMinError(printMessage);
      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (
      typeof oddsFiltersToValidate.max_odd_barrier != "undefined" &&
      JSON.parse(JSON.stringify(oddsFiltersToValidate.max_odd_barrier)) == ""
    ) {
      printMessage = "Missing Odds value.";
      if (JSON.parse(JSON.stringify(oddsFiltersToValidate.barrier_reaction_type)).value != "0") {
      }
      let message = [{ max_odd_barrier: "Missing Odds value." }];
      setValidationError(message);
      setTriggerValidationError(true);
      setBarrierMaxError(printMessage);
      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (
      Array.isArray(oddsFiltersToValidate.static_odd_reaction) &&
      oddsFiltersToValidate.static_odd_reaction.some(
        (item) => item.value === "" || item.value === null || item.value === undefined
      )
    ) {
      printMessage = "Missing Odds values.";
      if (JSON.parse(JSON.stringify(oddsFiltersToValidate.barrier_reaction_type)).value != "0") {
      }

      let message = [{ static_odd_reaction: "Missing Odds values." }];
      setValidationChildError(message);
      setTriggerValidationChildError(true);
      setBarrierStaticError(printMessage);
      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (parseFloat(oddsFiltersToValidate.min_odd_barrier) < 1) {
      invalid = true;
      printMessage = "The number can't be less than 1.";
      setBarrierMinError(printMessage);
      let message = [{ min_odd_barrier: "The number can't be less than 1." }];
      setValidationError(message);
      setTriggerValidationError(true);
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (parseFloat(oddsFiltersToValidate.max_odd_barrier) < 1) {
      invalid = true;
      printMessage = "The number can't be less than 1.";
            setValidationError([{ max_odd_barrier: "The number can't be less than 1." }]);
      setTriggerValidationError(true);
      setBarrierMaxError(printMessage);
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (
      parseFloat(oddsFiltersToValidate.min_odd_barrier) >
      parseFloat(oddsFiltersToValidate.max_odd_barrier)
    ) {
      printMessage = "The maximum Odds Price could not be less than the minimum Price.";
      let message = [
        {
          max_odd_barrier_min_odd_barrier:
            "The maximum Odds Price could not be less than the minimum Price.",
        },
      ];
      setValidationError(message);
      setTriggerValidationError(true);
      setBarrierMaxError(printMessage);

      message = [
        {
          min_odd_barrier_max_odd_barrier:
            "The minimum Odds Price could not be greater than the maximum Price.",
        },
      ];
      setValidationError(message);
      setTriggerValidationError(true);
      printMessage = "The minimum Odds Price could not be greater than the maximum Price.";
      setBarrierMinError(printMessage);
      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    oddsFiltersToValidate.margin_percent =
      oddsFiltersToValidate.margin_percent == "" ? 0 : oddsFiltersToValidate.margin_percent;

    if (
      oddsFiltersToValidate.margin_type &&
      oddsFiltersToValidate.margin_type.value != 0 &&
      parseFloat(oddsFiltersToValidate.margin_percent) <= 0
    ) {
      printMessage = "Margin percent couldn't be 0.";
      let message = [{ margin_percent: "Margin percent couldn't be 0." }];

      setValidationError(message);
      setTriggerValidationError(true);
      setMarginValueError(printMessage);

      invalid = true;
      if (tabErrors.indexOf(0) < 0) tabErrors.push(0);
    }

    if (invalid) {
      setTabError(tabErrors);
    } else {
      setValidationError([]);
      setTriggerValidationError(true);
    }

    selectTab(selectedTab);
  };

  const saveOddFilter = async (e) => {
    let oddsFilterToSend = {
      name: oddsFilters.odd_filter_name,
      platform: oddsFilters.platform,
      barrier_reaction_type: oddsFilters.barrier_reaction_type
        ? parseInt(oddsFilters.barrier_reaction_type.value)
        : barrierType.value,
      min_odd_barrier: oddsFilters.min_odd_barrier * 1,
      max_odd_barrier: oddsFilters.max_odd_barrier * 1,
      static_odd_reaction: Skill90OddFactorPriceSettingsData,
      margin_percent: oddsFilters.margin_percent * 1 != 0 ? oddsFilters.margin_percent * 1 : null,
      random_odd_reaction: oddsFilters.random_odd_reaction
        ? oddsFilters.random_odd_reaction.value
        : randomFactor.value,
      suspension_type: oddsFilters.suspension_type
        ? parseInt(oddsFilters.suspension_type.value)
        : suspensionType.value,
      margin_type: oddsFilters.margin_type
        ? parseInt(oddsFilters.margin_type.value)
        : marginType.value,
      suspension_provider: oddsFilters.suspension_provider
        ? oddsFilters.suspension_provider.length > 0
          ? oddsFilters.suspension_provider.map((item) => item.value).join(",")
          : null
        : null,
      mixing_odd_type: oddsFilters.mixing_odd_type
        ? parseInt(oddsFilters.mixing_odd_type.value)
        : mixingType.value,
      mixing_providers: selectedProviders
        ? selectedProviders.map((item) => {
            return {
              provider_id: item.value,
              provider_name: item.label,
              percentage: item.percentage / 100,
              auto: item.percentageToShow ? false : true,
            };
          })
        : [],
      mixing_odd_limit:
        oddsFilters.mixing_odd_limit * 1 != 0 ? oddsFilters.mixing_odd_limit * 1 : null,
    };
    showAlert(e, oddsFilterToSend);
  };

  const showAlert = (e, data) => {
    let event = e;
    let objectToSend = data;

    function returnEvent() {
      return event;
    }

    function returnData() {
      return objectToSend;
    }

    function returnId() {
      return id;
    }

    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let updatePlatformEndpoint = `/api/v1/oddsfilters/`;
        let data = returnData();

        let response = null;
        if (mode == "edit") {
          response = await putData(`${updatePlatformEndpoint}${id}`, data, {
            Authorization: getAuthorizationHeader(),
          });
        } else {
          response = await postData(updatePlatformEndpoint, data, {
            Authorization: getAuthorizationHeader(),
          });
        }

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log("I was closed by the timer");
        //routeChange();
      }

      signalCloseModal(returnEvent(), true);

      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Live Data didn't send to the platform. Please try again later!`,
          "error"
        );
      }
    });
  };

  const handleSignalCloseModal = (e) => {
    if (!e) return;
    e.preventDefault();

    if (Object.keys(oddsFilters).length == 0) {
      signalCloseModal(new Event("cancel"));
      return;
    }

    let oddsFilterToSend = {
      barrier_reaction_type: oddsFilters.barrier_reaction_type,
      min_odd_barrier: oddsFilters.min_odd_barrier,
      max_odd_barrier: oddsFilters.max_odd_barrier,
      static_odd_reaction: oddsFilters.static_odd_reaction ? oddsFilters.static_odd_reaction : [{}],
      margin_percent: oddsFilters.margin_percent ? oddsFilters.margin_percent : "0.0",
      random_odd_reaction: oddsFilters.random_odd_reaction,
      mixing_odd_type: oddsFilters.mixing_odd_type,
      suspension_type: oddsFilters.suspension_type,
      margin_type: oddsFilters.margin_type,
      suspension_provider: oddsFilters.suspension_provider
        ? {
            value: oddsFilters.suspension_provider.value,
            label: oddsFilters.suspension_provider.label,
            info: oddsFilters.suspension_provider.info,
          }
        : { value: 0, label: "None", info: "" },
      mixing_providers: selectedProviders.map((item) => {
        return {
          provider_id: item.value,
          provider_name: item.label,
          percentage: item.percentage,
        };
      }),
      mixing_odd_limit: oddsFilters.mixing_odd_limit ? oddsFilters.mixing_odd_limit : "0.0",
    };

    if (
      loadedData !=
      JSON.stringify(oddsFilterToSend)
        .replace("MAINPROVIDER", "")
        .replace(provider.name.toUpperCase(), "")
    ) {
      Swal.fire({
        title: `Unsaved Data!`,
        html: `You have unsaved changes! </br>Are you sure you want to cancel them?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          signalCloseModal(new Event("cancel"));
        } else {
          signalCloseModal(new Event("cancel cancel"));
        }
      });
    } else {
      signalCloseModal(new Event("cancel"));
    }
  };

  useEffect(() => {
    if (triggerValidationChildError) {
      setTriggerValidationChildError(false);
    }
  }, [triggerValidationChildError, validationChildError]);

  useEffect(() => {
    if (triggerValidationError) {
      setTriggerValidationError(false);
    }
  }, [triggerValidationError, validationError]);

  useEffect(() => {
    if (checkChanges) handleSignalCloseModal(new Event("checkChanges"));
  }, [checkChanges]);

  useEffect(() => {
    if (mixingProviders.length > 0 && selectedProviders.length > 0) {
      for (let index = 0; index < selectedProviders.length; index++) {
        const selectedProvider = selectedProviders[index];
        const mixing = mixingProviders.find((provider) => provider.label == selectedProvider.label);
        if (mixing) mixing.selected = true;
      }
      validateData();
    }
  }, [mixingProviders, selectedProviders]);

  useEffect(() => {
    // if (provider.id == 1000) {
    //   setMainPercentage(0);
    //   let mixingTypesFiltered = tabsStatic[1].config.type;
    //   mixingTypesFiltered = mixingTypesFiltered.filter((item) => item.value != 0);
    //   setMixingTypes(mixingTypesFiltered);
    //   setMixingType(mixingTypesFiltered[1]);
    //   handleFiltersSelectionsChange(mixingTypesFiltered[1], "mixing-type");
    // }
    // if (provider.id != 1000) setMainPercentage(0);
    // setRestPercentage(0);
    // restPercentageCache = 0;
  }, [provider]);

  useEffect(() => {
    // console.log("id: ", id);
    // console.log("initData: ", initData);
    if (id > 0) {
      getStaticData();
      getDataFromDB(initData);
    } else {
      getStaticData();
    }
  }, [id, providers, platform]);

  return (
    <SoftBox>
      <TableContainer style={{ overflow: "visible" }}>
        <SoftBox p={3} sx={{ overflow: "visible", paddingTop: "0px !important" }}>
          <SoftBox>
            <Grid container spacing={2} item xs={8} md={8}>
              <Grid item xs={4} md={4}>
                <FormField
                  id="odd-filter-name"
                  type="text"
                  error={oddFilterNameError != ""}
                  success={oddFilterNameError == ""}
                  name="odd-filter-name"
                  label="Odds Filter Name"
                  info="The name will be visible in order to apply in filters "
                  infoPlacement="top"
                  infoWidth="200"
                  placeholder="Eg. My filter"
                  defaultValue={oddFilterName}
                  onChange={handleInputValueChange}
                  onBlur={handleFocusOut}
                />
                <span className="validation-error">{oddFilterNameError}</span>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
            sm={8}
          >
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Odds Suspension Settings" {...a11yProps(0)} />
              <Tab label="Odds Price Settings" {...a11yProps(1)} />
            </Tabs>
          </SoftBox>
          <TabPanel value={value} index={0}>
            <SoftBox
              mt={2}
              style={{
                paddingBottom: "15px",
              }}
            >
              <Grid container spacing={3} id="barrier-setup-holder">
                <Grid container spacing={2} item xs={12} md={12}>
                  <Grid item xs={4} md={4}>
                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                      >
                        Suspend Market&apos;s Odds WHEN
                      </SoftTypography>
                      <HtmlTooltip
                        placement={"top"}
                        maxwidth={200}
                        title={
                          <React.Fragment>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              <div style={{ display: "block" }}>{"Apply only to FTB provider"}</div>
                            </div>
                          </React.Fragment>
                        }
                      >
                        <Icon className="info-icon" title="">
                          info_outlined
                        </Icon>
                      </HtmlTooltip>
                    </SoftBox>
                    <SoftSelect
                      id="suspension-type"
                      value={suspensionType}
                      options={suspensionTypes}
                      onChange={(item) => handleFiltersSelectionsChange(item, "suspension-type")}
                    />
                  </Grid>
                  <Grid item xs={8} md={8} display={suspensionType.value == 5 ? "" : "none"}>
                    <Grid item xs={12} md={12}>
                      <Grid
                        container
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid item xs={12} md={6} sm={6} ml={0.0} justifyContent="center">
                          <SoftBox position="relative" height="max-content" mx="auto">
                            <Card
                              sx={{
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              <SoftBox py={2} px={2}>
                                <FormControl>
                                  <SoftBox pb={2}>
                                    <SoftTypography variant="h6" fontWeight="medium">
                                      Available Providers:
                                    </SoftTypography>
                                  </SoftBox>
                                  <FormGroup row className="available-providers">
                                    {mixingProvidersMarkets.map((provider) => (
                                      <FormGroup
                                        row
                                        key={`${provider.value}-holder`}
                                        className="available-providers-item"
                                      >
                                        <FormControlLabel
                                          className="providers-checkbox"
                                          control={
                                            <Checkbox
                                              checked={
                                                suspensionProviderBarrier.find(
                                                  (item) => item.value === provider.value
                                                )
                                                  ? true
                                                  : false
                                              }
                                              onClick={(e) =>
                                                handleFiltersSelectionsChange(
                                                  provider,
                                                  "suspension-provider-barrier"
                                                )
                                              }
                                              name={String(provider.value)}
                                            />
                                          }
                                          key={`${provider.value}-checkbox`}
                                        />
                                        <SoftTypography
                                          key={`${provider.value}-label`}
                                          className="provider-checkbox-label"
                                          sx={{ minWidth: "40px !important" }}
                                        >
                                          {provider.label}
                                        </SoftTypography>
                                      </FormGroup>
                                    ))}
                                  </FormGroup>
                                </FormControl>
                              </SoftBox>
                            </Card>
                          </SoftBox>
                        </Grid>
                        <Grid item xs={12} md={5} sm={5} ml={0.0} justifyContent="center">
                          <SoftBox position="relative" height="max-content" mx="auto">
                            <Card
                              sx={{
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              <SoftBox py={2} px={2}>
                                <FormControl>
                                  <SoftBox pb={2}>
                                    <SoftTypography variant="h6" fontWeight="medium">
                                      Providers Priority:
                                    </SoftTypography>
                                  </SoftBox>
                                  <SoftBox className="providers-priority-holder">
                                    {suspensionProviderBarrier.map((provider, index) => (
                                      <SoftTypography
                                        key={`${provider.value}-label`}
                                        className="provider-priority-label"
                                      >
                                        {index + 1}. {provider.label}
                                      </SoftTypography>
                                    ))}
                                  </SoftBox>
                                </FormControl>
                              </SoftBox>
                            </Card>
                          </SoftBox>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={2} item xs={12} md={12}>
                  <hr
                    style={{
                      border: "1px solid rgb(240, 240, 240)",
                      marginRight: "20px",
                      width: "100%",
                    }}
                  ></hr>
                </Grid>
                <Grid container spacing={2} item xs={8} md={8}>
                  <Grid item xs={3} md={3}>
                    <FormField
                      id="barrier-minimum"
                      type="number"
                      inputProps={{
                        maxLength: 10,
                        step: "0.01",
                      }}
                      error={barrierMinError != ""}
                      success={barrierMinError == ""}
                      name="barrier-minimum"
                      label="Minimun Odds price"
                      info="The Odds with LOWER price than 'Minimum Odds Price' will be affected from the Selected Setup below."
                      infoPlacement="top"
                      infoWidth="200"
                      placeholder="Eg. 2.00"
                      defaultValue={minBarrier}
                      onChange={handleInputValueChange}
                      onBlur={handleFocusOut}
                    />
                    <span className="validation-error">{barrierMinError}</span>
                  </Grid>
                  <Grid item xs={3} md={3}>
                    <FormField
                      id="barrier-maximum"
                      type="number"
                      inputProps={{
                        maxLength: 10,
                        step: "0.01",
                      }}
                      error={barrierMaxError != ""}
                      success={barrierMaxError == ""}
                      name="barrier-maximum"
                      label="Maximum Odds price"
                      info="The Odds with GREATER price than 'Maximum Odds Price' will be affected from the Selected Setup below."
                      infoPlacement="top"
                      infoWidth="200"
                      placeholder="Eg. 10.00"
                      defaultValue={maxBarrier}
                      onChange={handleInputValueChange}
                      onBlur={handleFocusOut}
                    />
                    <span className="validation-error">{barrierMaxError}</span>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                      >
                        actions for the odds out of the previous limits (minimum - maximum)
                      </SoftTypography>
                      {/* <Icon className="info-icon" title="">
                      info_outlined
                    </Icon> */}
                    </SoftBox>
                    <SoftSelect
                      id="barrier-type"
                      value={barrierType}
                      options={barrierTypes}
                      onChange={(item) => handleFiltersSelectionsChange(item, "barrier-type")}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} item xs={4} md={4}>
                  <SoftBox
                    p={1.8}
                    mb={2}
                    mt={2}
                    ml={2}
                    borderRadius="lg"
                    bgColor="info"
                    color="white"
                    shadow="lg"
                    style={{
                      display: infoDataOddSettings === "" ? "none" : "",
                      height: "fit-content",
                      width: "max-content",
                      position: "relative",
                      bottom: "0px",
                      lineHeight: 1,
                    }}
                  >
                    <Icon id="" style={{ marginRight: "10px" }}>
                      info_icon
                    </Icon>
                    <span className="wizard-formfield-info">
                      This Setup will give you the ability to {infoDataOddSettings}
                    </span>
                  </SoftBox>
                </Grid>
              </Grid>
            </SoftBox>
          </TabPanel>
          <TabPanel
            value={value}
            index={1}
            style={{
              minHeight: provider.id == 1000 ? "calc(60vh)" : "calc(60vh)",
              maxHeight: "calc(70vh)",
              overflow: provider.id == 1000 ? "auto" : "",
              scrollbarWidth: "thin",
              // height: "max-content",
            }}
          >
            <SoftBox mt={2} style={{ marginBottom: "80px" }}>
              <Grid container spacing={3} id="mixing-options-holder">
                <Skill90OddFactorPriceSettings
                  initialData={Skill90OddFactorPriceSettingsData}
                  onDataChange={handleDataChange}
                  onValidationError={handleValidationError}
                />

                <Grid container spacing={2} item xs={12} md={12}>
                  <hr
                    style={{
                      border: "1px solid rgb(240, 240, 240)",
                      marginRight: "20px",
                      width: "100%",
                    }}
                  ></hr>
                </Grid>
                <Grid container spacing={2} item xs={12} md={12}>
                  <Grid item xs={3} md={3}>
                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize"
                      >
                        Select Margin Type
                      </SoftTypography>
                      {/* <Icon className="info-icon" title="">
                      info_outlined
                    </Icon> */}
                    </SoftBox>
                    <SoftSelect
                      id="margin-type"
                      style={{ zIndex: 1000000 }}
                      value={marginType}
                      options={marginTypes}
                      onChange={(item) => handleFiltersSelectionsChange(item, "margin-type")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    md={3}
                    className={marginType.value == 0 ? "disabled-form-item" : ""}
                  >
                    <FormField
                      id="margin-value"
                      type="number"
                      inputProps={{
                        min: 0,
                        max: 100,
                        step: "0.1",
                        readOnly: marginType.value == 0,
                      }}
                      error={marginValueError != ""}
                      success={marginValueError == ""}
                      name="margin-value"
                      label="Margin Value (Percentage %)"
                      info="This Margin value percentage will be applied to all Odds at the end of the odds manipulation."
                      infoPlacement="top"
                      infoWidth="200"
                      placeholder="Eg. 1.2"
                      defaultValue={marginValue}
                      onChange={handleInputValueChange}
                      onBlur={handleFocusOut}
                    />
                    <span className="validation-error">{marginValueError}</span>
                  </Grid>
                </Grid>
                <Grid container spacing={2} item xs={12} md={12}>
                  <hr
                    style={{
                      border: "1px solid rgb(240, 240, 240)",
                      marginRight: "20px",
                      width: "100%",
                    }}
                  ></hr>
                </Grid>
                <Grid container spacing={2} item xs={8} md={8} sx={{ height: "fit-content" }}>
                  <Grid item xs={12} md={12}>
                    <Grid container spacing={2} item xs={12} md={12}>
                      <Grid item xs={6} md={6}>
                        <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SoftTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            select mixing type
                          </SoftTypography>
                          <HtmlTooltip
                            placement={"top"}
                            maxwidth={200}
                            title={
                              <React.Fragment>
                                <div style={{ display: "flex", flexWrap: "wrap" }}>
                                  <div style={{ display: "block" }}>
                                    {infoData + " - Apply only to FTB provider"}
                                  </div>
                                </div>
                              </React.Fragment>
                            }
                          >
                            <Icon className="info-icon" title="">
                              info_outlined
                            </Icon>
                          </HtmlTooltip>
                        </SoftBox>
                        <SoftSelect
                          id="mixing-type"
                          value={mixingType}
                          options={mixingTypes}
                          onChange={(item) => handleFiltersSelectionsChange(item, "mixing-type")}
                        />
                        <span className="validation-error">{mixingTypeError}</span>
                      </Grid>
                      <Grid
                        item
                        xs={5}
                        md={5}
                        sx={{ display: mixingType && mixingType.value != 0 ? "" : "none" }}
                      >
                        <FormField
                          id="mixing-providers-limit-value"
                          type="number"
                          inputProps={{
                            min: 0,
                            max: 100,
                            step: "0.1",
                            readOnly: false,
                          }}
                          error={mixingOddValueError != ""}
                          success={mixingOddValueError == ""}
                          name="mixing-providers-limit-value"
                          label="Providers Odds Limit (Percentage %)"
                          info="if one Provider's price is higher than ex. 30% of the
                          lowest price then discard it"
                          infoPlacement="top"
                          infoWidth="200"
                          placeholder="Eg. 1.2"
                          disabled={false}
                          defaultValue={mixingOddValue}
                          onChange={handleInputValueChange}
                          onBlur={handleFocusOut}
                        />
                        <span className="validation-error">{mixingOddValueError}</span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ display: mixingType.value == "0" ? "none" : "" }}
                  >
                    <Grid
                      container
                      style={{
                        display: mixingType.value == "0" ? "none" : "",
                        justifyContent: "space-between",
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        md={4}
                        sm={4}
                        ml={0.5}
                        justifyContent="center"
                        style={{ display: mixingType.value == "0" ? "none" : "" }}
                      >
                        <SoftBox position="relative" height="max-content" mx="auto">
                          <Card
                            sx={{
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <SoftBox py={2} px={2}>
                              <FormControl>
                                <SoftBox pb={2}>
                                  <SoftTypography variant="h6" fontWeight="medium">
                                    Select Providers to mix:
                                  </SoftTypography>
                                </SoftBox>
                                <FormGroup row>
                                  {mixingProviders.map((provider) => (
                                    <FormGroup row key={`${provider.value}-holder`}>
                                      <FormControlLabel
                                        className="providers-checkbox"
                                        control={
                                          <Checkbox
                                            checked={provider.selected}
                                            onClick={handleProviderChange}
                                            name={String(provider.value)}
                                          />
                                        }
                                        key={`${provider.value}-checkbox`}
                                      />
                                      <SoftTypography
                                        key={`${provider.value}-label`}
                                        className="provider-checkbox-label"
                                      >
                                        {provider.label}
                                      </SoftTypography>
                                    </FormGroup>
                                  ))}
                                </FormGroup>
                              </FormControl>
                            </SoftBox>
                          </Card>
                        </SoftBox>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container spacing={2} item xs={4} md={4}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sm={12}
                    mr={0.5}
                    container
                    justifyContent="center"
                    style={{ display: mixingType.value == "2" ? "" : "none" }}
                  >
                    <Card
                      sx={{
                        height: "100%",
                        width: "100%",
                        display: selectedProviders.length > 0 ? "" : "none",
                      }}
                    >
                      <SoftBox pt={2} px={2} display="inline-block">
                        <SoftTypography variant="label" fontWeight="medium">
                          Providers Percentage Weight:
                        </SoftTypography>
                        <HtmlTooltip
                          placement={"top"}
                          maxwidth={200}
                          title={
                            <React.Fragment>
                              <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <div style={{ display: "block" }}>
                                  {provider.id == 1000
                                    ? infoPercentageData.replace("Main", "other")
                                    : infoPercentageData}
                                </div>
                              </div>
                            </React.Fragment>
                          }
                        >
                          <Icon className="info-icon">info_outlined</Icon>
                        </HtmlTooltip>
                      </SoftBox>
                      <SoftBox
                        pt={0}
                        px={2}
                        style={{ display: mixingPercentageError ? "" : "none" }}
                      >
                        <SoftTypography style={{ fontSize: "11px", color: "red" }}>
                          {provider.id == 1000
                            ? "The Mixing Provider's Percentage Weight sould be SUM to 100. Please Moderate Providers Percentages."
                            : "Main Provider's Percentage Weight sould be 1% or more. Please Moderate Providers Percentages."}
                        </SoftTypography>
                      </SoftBox>
                      <SoftBox pt={2} px={2}>
                        <SoftBox
                          component="ul"
                          display="flex"
                          flexDirection="column"
                          p={0}
                          m={0}
                          mb={0.75}
                          sx={{ listStyle: "none" }}
                        >
                          <SoftBox
                            key={provider.id + "-holder"}
                            component="li"
                            w="100%"
                            py={1}
                            mb={0.5}
                            style={{ backgroundColor: "aliceblue" }}
                            sx={{ display: provider.id == 1000 ? "none" : "" }}
                          >
                            <SoftBox
                              key={provider.id + "-rowHolder-name"}
                              display="flex"
                              justifyContent="space-between"
                              alignItems="right"
                              mb={1}
                            >
                              <SoftTypography
                                key={provider.id + "-name"}
                                variant="button"
                                fontWeight="medium"
                                color="text"
                                textTransform="capitalize"
                                style={{ width: "100%", paddingLeft: "10px" }}
                              >
                                {provider.name}
                              </SoftTypography>
                              <SoftTypography
                                key={provider.id + "-percentage-view"}
                                variant="button"
                                fontWeight="medium"
                                color="text"
                                textTransform="capitalize"
                                style={{ paddingRight: "10px" }}
                              >
                                {100 - restPercentage}%
                              </SoftTypography>
                            </SoftBox>
                            <SoftProgress variant="gradient" value={100 - restPercentage} />
                          </SoftBox>
                          {selectedProviders
                            .sort((a, b) => b.percentage - a.percentage)
                            .map((provider) => (
                              <SoftBox
                                key={provider.value + "-holder"}
                                component="li"
                                w="100%"
                                py={1}
                                mb={0.5}
                              >
                                <SoftBox
                                  key={provider.value + "-rowHolder-name"}
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="right"
                                  mb={0}
                                >
                                  <SoftTypography
                                    key={provider.value + "-name"}
                                    variant="button"
                                    fontWeight="medium"
                                    color="text"
                                    textTransform="capitalize"
                                    style={{ width: "100%", paddingLeft: "10px" }}
                                  >
                                    {provider.label}
                                  </SoftTypography>
                                  <SoftTypography
                                    style={{ display: "none" }}
                                    key={provider.value + "-percentage-view"}
                                    variant="button"
                                    fontWeight="medium"
                                    color="text"
                                    textTransform="capitalize"
                                  >
                                    {provider.percentage}%
                                  </SoftTypography>
                                  <SoftInput
                                    title={!provider.percentageToShow ? "Auto configured" : ""}
                                    key={provider.value + "-percentage-edit"}
                                    size="small"
                                    style={{ width: "30px !important", textAlign: "right" }}
                                    className="editable-cell-percentage to-edit"
                                    placeholder={parseFloat(provider.percentage)
                                      .toFixed(2)
                                      .toString()}
                                    name={provider.label}
                                    defaultValue={provider.percentageToShow}
                                    onChange={handleProviderPercentage}
                                    onBlur={handleSortingProviderPercentage}
                                    onKeyDown={keyDownHandler}
                                  />
                                  <SoftTypography
                                    key={provider.value + "-name-symbol"}
                                    variant="button"
                                    fontWeight="medium"
                                    color="text"
                                    textTransform="capitalize"
                                    style={{ paddingRight: "10px" }}
                                  >
                                    %
                                  </SoftTypography>
                                </SoftBox>
                                <SoftProgress
                                  className={"custom-progress-" + provider.label}
                                  variant="gradient"
                                  color="success"
                                  value={provider.percentage}
                                  customColor={provider.label + "-gradient"}
                                />
                              </SoftBox>
                            ))}
                        </SoftBox>
                      </SoftBox>
                    </Card>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    display: selectedTab == 1 && tabError.indexOf(0) > -1 ? "" : "none",
                    textAlign: "right",
                  }}
                >
                  {/* <span className="wizard-validation-error">{validationError}</span> */}
                  <span className="wizard-validation-error">
                    {validationError && validationError.length > 0 && (
                      <div>
                        {validationError.map((error, index) => (
                          <div key={index}>
                            {typeof error === "object"
                              ? Object.values(error).join(" ") // Or adjust to target specific properties
                              : error}
                          </div>
                        ))}
                      </div>
                    )}
                  </span>
                </Grid>
              </Grid>
            </SoftBox>
          </TabPanel>

          <SoftBox>
            <Grid container justifyContent="right">
              <Grid item>
                <SoftButton variant="outlined" color="info" onClick={handleSignalCloseModal}>
                  Cancel
                </SoftButton>
              </Grid>
              <Grid item>
                <SoftButton
                  type="submit"
                  variant="gradient"
                  color="dark"
                  disabled={
                    validationError.length > 0 || validationChildError.length > 0 ? true : false
                  }
                  onClick={(e) => saveOddFilter(e)}
                >
                  save
                </SoftButton>
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </TableContainer>
    </SoftBox>
  );
}

// Typechecking props for the DataTable
NewOddsFilter.propTypes = {
  id: PropTypes.number,
  initData: PropTypes.object,
  providers: PropTypes.array,
  signalCloseModal: PropTypes.func,
  checkChanges: PropTypes.bool,
};

export default NewOddsFilter;
